module.exports = __webpack_public_path__ + "static/img/pc-web-sub-img02@t.5de4ba0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/hyundai-steel/pc-web-sub-img02@t.png
// module id = TeA6
// module chunks = 0